(function($) {
	
	$(document).ready(function(){
	
		// External links
		$('a[rel="external"]').click(function(){
			window.open( $(this).attr('href') );
			return false;
		});
		$('a[href*="#"]').on('click', function(event){     
			event.preventDefault();
			$('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
		});
		// 
		
		// Mobile Menu 
		$('.navbar-toggler').on('click', toggleNavigation);
		function toggleNavigation(e) {
			if( $('body').hasClass('mobile_nav--active') ) {
				// close nav
				$('body, .navbar-nav__wrapper').removeClass('mobile_nav--active');
			} else {
				// open nav
				$('body, .navbar-nav__wrapper').addClass('mobile_nav--active');
			}
		}
		//

		// Floating menu 
		$(window).scroll(function(){
			var s = $(window).scrollTop();
			console.log('scrollTop', s);
			if( s > 75 ) {
				$('header').addClass('header--small');
			} else {
				$('header').removeClass('header--small');
			}
		});
		//

		// Textarea autogrow
		$(".wpcf7-textarea").autoGrow();
		//

		// Sticky kit
		/* function make_sticky() {
			window_width = $( window ).width();
			if (window_width < 768) {
				console.log('unstick');
				$(".sticky").trigger("sticky_kit:detach");
			} else {
				console.log("stick in parent");
				$(".sticky").stick_in_parent();
			}
		}
		make_sticky();
		$( window ).resize(function() {
			make_sticky();
		}); */
		//
		
		// Magnific popup
		$(".image-link").magnificPopup({
			type: "image",
			gallery: {
				enabled: true
			},
			zoom: {
				enabled: true,
				duration: 300,
				easing: "ease-in-out",
				opener: function(openerElement) {
					return openerElement.is("img") ? openerElement : openerElement.find("img");
				}
			},
			callbacks: {
				open: function() {}
			}
		});
	
		$.magnificPopup.instance.open = function(data) {
			var $el = $(data.el);
			if (!$el.hasClass("slick-active") && $el.parent().hasClass("slick-track")) {
				return;
			}
			$.magnificPopup.proto.open.call(this, data);
		};
		//

		// Slick image slider
		$(".image-slider").slick({
			variableWidth: true,
			focusOnSelect: true,
			infinite: true,
			centerMode: true
		});
		//

		// Newsletter subscription
		$('#newsletter_subscribe #signup').on('click', function(e) {
			e.preventDefault();
			var mailchimpform = $('#newsletter_subscribe');
			var email = $('#newsletter #email');
			var daaaata = mailchimpform.serialize();
			mailchimpform.removeClass('shake');
			mailchimpform.removeClass('has-error');

			var has_error = false;
			if (email.val() !== '' && validateEmail(email.val())) {
				$.ajax({
					url: $('#mcapiurl').val(),
					type:'POST',
					data: daaaata,
					error: function(err) {
						$('.alert.failure').slideDown().delay(2500).slideUp();
					},
					success: function(data){
						$('.alert.success').slideDown().delay(2500).slideUp();
						email.val('');
						mailchimpform[0].reset();
					}
				});
			} else {
				mailchimpform.addClass('has-error');
				has_error = true;
			}

			if(has_error) {
				mailchimpform.addClass('shake');
				setTimeout(function() {
					mailchimpform.removeClass('shake');
				}, 1000);
			}
		});

		function validateEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		}
		//

	});
		
})( jQuery );